export default function CampaignTerms() {
  return (
    <section id="terms" className="relative w-full bg-background-100 py-20 md:py-28">
      <div className="w-full px-6 md:px-16">
        <div className="max-w-3xl mx-auto">
          <p className="font-sans text-[12px] tracking-[0.2em] text-foreground-400 mb-10 text-center">
            INFORMATION ／ キャンペーン規約
          </p>

          <div className="bg-background-50 border border-foreground-200/60 p-8 md:p-12">
            <ul className="space-y-4">
              <li
                className="font-sans text-[14px] md:text-[15px] tracking-[0.03em] leading-[1.9] text-foreground-500"
                style={{ fontWeight: 300 }}
              >
                ※ 抽選対象は 1ご家族につき1名様となります。
              </li>
              <li
                className="font-sans text-[14px] md:text-[15px] tracking-[0.03em] leading-[1.9] text-foreground-500"
                style={{ fontWeight: 300 }}
              >
                ※ 当選連絡先を含むアンケートへのご回答が必要です。
              </li>
              <li
                className="font-sans text-[14px] md:text-[15px] tracking-[0.03em] leading-[1.9] text-foreground-500"
                style={{ fontWeight: 300 }}
              >
                ※ 過去にGIAZOのモデルハウスへご来場された方は対象外となる場合がございます。
              </li>
              <li
                className="font-sans text-[14px] md:text-[15px] tracking-[0.03em] leading-[1.9] text-foreground-500"
                style={{ fontWeight: 300 }}
              >
                ※ Web事前予約のないご来場は、特典の対象外となります。
              </li>
              <li
                className="font-sans text-[14px] md:text-[15px] tracking-[0.03em] leading-[1.9] text-foreground-500"
                style={{ fontWeight: 300 }}
              >
                ※ 対象展示場以外へのご来場は、キャンペーン対象外となります。
              </li>
              <li
                className="font-sans text-[14px] md:text-[15px] tracking-[0.03em] leading-[1.9] text-foreground-500"
                style={{ fontWeight: 300 }}
              >
                ※ 対象期間（2026年7月20日〜8月30日）外のご来場は、キャンペーン対象外となります。
              </li>
              <li
                className="font-sans text-[14px] md:text-[15px] tracking-[0.03em] leading-[1.9] text-foreground-500"
                style={{ fontWeight: 300 }}
              >
                ※ 抽選はキャンペーン終了後に実施し、当選者の発表は当選者様へのご連絡をもって代えさせていただきます。
              </li>
              <li
                className="font-sans text-[14px] md:text-[15px] tracking-[0.03em] leading-[1.9] text-foreground-500"
                style={{ fontWeight: 300 }}
              >
                ※ 本キャンペーンは予告なく変更・終了する場合がございます。
              </li>
            </ul>

            <p
              className="mt-8 pt-6 border-t border-foreground-200/40 font-sans text-[13px] tracking-[0.03em] leading-[1.9] text-foreground-400 text-center"
              style={{ fontWeight: 300 }}
            >
              ※その他不明点は、各展示場または創建ホームまでお問い合わせください。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}